
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/decisions/[id]",
      function () {
        return require("private-next-pages/decisions/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/decisions/[id]"])
      });
    }
  